<div class="spinner-container">
    <mat-spinner></mat-spinner>
</div>